import Header from '../../component/header/Header'
import Icons from '../../Constants/Icons'
import { useState, useRef } from 'react'
import CustomSlider from '../../component/customSlider/CustomSlider'
import PartnersSlider from '../../component/customSlider/PartnersSlider'
import ReviewsSlider from '../../component/customSlider/ReviewsSlider'
import Footer from '../../component/footer/Footer'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { ToastContainer } from 'react-toastify'
import { Link } from 'react-router-dom'
import ReCAPTCHA from 'react-google-recaptcha'
import QuestionsForm from '../../component/CustomForm/QuestionsForm'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import { MessageCircle, BadgeDollarSign, DollarSign } from 'lucide-react'

const Home = () => {
  const [value, setValue] = useState()
  const readersRef = useRef(null)
  const offersRef = useRef(null)
  const centRisRef = useRef(null)
  const buyersRef = useRef(null)
  const aboutRef = useRef(null)
  const partnerRef = useRef(null)
  const reviewsRef = useRef(null)

  const sectionRefs = {
    'Property Estimate': readersRef,
    'Cash Offers': offersRef,
    MLS: centRisRef,
    'Buyer’s': buyersRef,
    'About us': aboutRef,
    'Partner’s': partnerRef,
    Reviews: reviewsRef
  }

  const scrollToSection = label => {
    sectionRefs[label]?.current?.scrollIntoView({ behavior: 'smooth' })
  }
  const { t } = useTranslation()

  const contactRef = useRef(null)
  const handelContact = () => {
    contactRef?.current?.scrollIntoView({ behavior: 'smooth' })
  }
  const steps = [
    {
      title: 'STEP 1',
      icon: MessageCircle,
      // heading: 'CONTACTEZ NOUS',
      description:
        'Send us your home information and we will get in touch with you with any questions.'
    },
    {
      title: 'STEP 2',
      icon: BadgeDollarSign,
      // heading: 'OBTENEZ VOTRE OFFRE',
      description: 'Get your Offer'
    },
    {
      title: 'STEP 3',
      icon: DollarSign,
      // heading: 'RECEVEZ VOTRE ARGENT',
      description: 'Get Paid'
    }
  ]
  return (
    <div>
      <div
        style={{ position: 'relative', zIndex: '2', backgroundColor: 'white' }}
      >
        <Header scrollToSection={scrollToSection} />
        <section
          id='banners'
          className='vc_row bg-cover pt-70 pb-20 d-flex flex-wrap align-items-center'
          style={{
            backgroundImage: `url(${Icons.bg115})`,
            backgroundRepeat: 'no-repeat'
          }}
          data-parallax='true'
          data-parallax-options='{"parallaxBG": true, "overflowHidden": true}'
        >
          <div className='content_center_box'>
            <div className='content_boxs'>
              <div className='container'>
                <h1>Welcome to MaisonsDirect</h1>
                <h4>Sell Your Property, Stress-Free and Fast!</h4>
              </div>
            </div>
          </div>
        </section>

        <section ref={readersRef} id='homeestimate' className='vc_row ptb'>
          <div className='container'>
            <div className='row'>
              <div className='lqd-column col-lg-5 col-md-6 mb-200 mb-md-0'>
                <div className='section-title left'>
                  <h1>Property Estimate</h1>
                </div>
                <div className='home_content_boxs'>
                  <p>
                    Find out what your property is worth! Find out in 24 hours!
                    We will call you and provide a full report with comparable
                    properties. Completely FREE
                  </p>
                </div>
              </div>
              <div className='lqd-column col-lg-5 col-md-6 col-lg-offset-2 pull-up'>
                <div
                  className='lqd-column-inner bg-cover bg-center p-4'
                  data-parallax='true'
                  data-parallax-from='{"translateY":-135}'
                  data-parallax-to='{"translateY":110}'
                  data-parallax-options='{"overflowHidden": false}'
                  style={{ backgroundImage: `url(${Icons.bg116})` }}
                >
                  <h4>Free Property Evaluation</h4>
                  <div className='contact-form contact-form-inputs-filled contact-form-button-block font-size-14'>
                    <QuestionsForm />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <CustomSlider />
        <section
          ref={offersRef}
          id='cashoffers'
          className='vc_row bg-contain ptb'
          style={{
            backgroundImage: `url(${Icons.happy_house})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center'
          }}
        >
          <div className='container'>
            <div className='section-title'>
              <h1>Cash Offers</h1>
            </div>
            <h2 style={{ color: 'white', position: 'relative' }}>
              Get a Cash Offer on your property !! <br></br>Sell your property
              headache free!
            </h2>
            <div className='forms_content'>
              <div className='row Cash-flex'>
                {/* Left Side: Form */}
                <div className='col-md-6'>
                  <div
                    className='offers_boxs forms'
                    style={{
                      backgroundImage: 'none',
                      paddingTop: '0px',
                      paddingLeft: '8px',
                      marginTop: '-20px'
                    }}
                  >
                    <div
                      style={{
                        color: 'rgba(255, 255, 255, 0.91)',
                        fontSize: '30px',
                        fontWeight: '300'
                      }}
                    >
                      Sell your property in less than 30 days!
                    </div>
                    <div className='contact-form contact-form-inputs-filled contact-form-button-block font-size-14'>
                      <form>
                        <div className='row'>
                          <div className='col-md-12'>
                            <textarea
                              className='form-control'
                              placeholder='Address'
                            ></textarea>
                          </div>
                          <div className='col-md-6 Province-select'>
                            <select
                              className='form-control'
                              placeholder='Province'
                              style={{ margin: '0' }}
                            >
                              <option>Select a Province</option>
                              <option>AB</option>
                              <option>DC</option>
                              <option>MB</option>
                              <option>NL</option>
                              <option>Sk</option>
                            </select>
                          </div>
                          <div className='col-md-6'>
                            <input
                              type='text'
                              className='form-control'
                              placeholder='Full Name'
                            />
                          </div>
                          <div className='col-md-6'>
                            {/* <input
                              type='text'
                              className='form-control'
                              placeholder='Phone Number'
                            /> */}
                            <PhoneInput
                              country={'ca'}
                              className='PhoneInput'
                              placeholder='Phone Number'
                              value={value}
                              onChange={setValue}
                            />
                          </div>
                          <div className='col-md-6'>
                            <input
                              type='email'
                              className='form-control'
                              placeholder='Email'
                            />
                          </div>
                          <div className='col-md-12 button_box text-md-center'>
                            <input
                              style={{
                                backgroundColor: 'rgba(23,137,28,1)',
                                border: 'none',
                                width: 'auto',
                                color: 'white',
                                marginTop: '15px'
                              }}
                              type='submit'
                              className='text-white  rounded cursor-pointer'
                              value='Get my Cash Offer'
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                {/* Right Side: Information */}
                <div className='col-md-6'>
                  <div className='offers_boxs contents condition-box'>
                    <ul>
                      <li>
                        <p>We buy houses, no matter the condition</p>
                      </li>
                      <li>
                        <p>
                          No repairs needed (We purchase in as-is condition)
                        </p>
                      </li>
                      <li>
                        <p>No hidden fees & 0 obligation</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div
              className='making-offer'
              style={{ position: 'relative', textAlign: 'center' }}
            >
              <p>
                Don’t wait to sell your house before making an offer on your
                dream house.
              </p>
              <p>
                <b>
                  Take advantage of our cash offers to get pre-approved for your
                  next purchase
                </b>
              </p>
            </div>
          </div>
        </section>

        <section>
          <div className='steps'>
            <div className='section-title'>
              <h1 style={{ color: 'white' }}>The process:</h1>
            </div>
            <div className='steps__container'>
              {steps.map((step, index) => (
                <div key={index} className='step-card'>
                  <div className='step-card__header text-center'>
                    <h3 className='step-card__title'>{step.title}</h3>
                  </div>
                  <div>
                    <step.icon
                      className='step-card__icon'
                      style={{ color: 'black', height: '60px', width: '60px' }}
                    />
                  </div>
                  <div className='step-card__content'>
                    <h4 className='step-card__heading'>{step.heading}</h4>
                    <p className='step-card__description'>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section
          ref={centRisRef}
          id='centrisMLS'
          className='vc_row bg-contain ptb MLS'
        >
          <div className='container'>
            <div className='section-title'>
              <h1>MLS</h1>
            </div>
            <div className='about_boxs'>
              <div className='row'>
                <div className='col-md-6'>
                  <div className='offers_boxs contents'>
                    <h4>List your property on the Market</h4>
                    <ul>
                      <li>
                        <p>
                          If you don’t want a cash offer, our team of affiliate
                          brokers can list your property on the market for
                          additional exposure.
                        </p>
                      </li>
                      <li>
                        <p>
                          Lowest listing commission guaranteed or we will price
                          match!
                          <span
                            onClick={handelContact}
                            style={{
                              cursor: 'pointer',
                              color: 'blue',
                              textDecoration: 'underline'
                            }}
                          >
                            {' '}
                            Contact us{' '}
                          </span>
                          today to learn more
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='col-md-6'>
                  <div className='img_boxs'>
                    <img
                      src={Icons.centrisMLS}
                      alt='Centris MLS'
                      className='w-full h-auto'
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <CustomSlider />
        {/* <section
          ref={buyersRef}
          id='buyers'
          className='vc_row bg-contain ptb'
          style={{ backgroundImage: `url(${Icons.bg120})` }}
        >
          <div className='container'>
            <div className='section-title'>
              <h1>Buyer’s</h1>
            </div>
            <div className='forms_content'>
              <div className='row'>
                <div className='col-md-6'>
                  <div className='offers_boxs contents'>
                    <h4>The best properties at the best prices.</h4>
                    <h5>What we offer</h5>
                    <ul>
                      <li>
                        <p>
                          <b>Real Estate Investors:</b> Be first in line to
                          receive exclusive offers before they hit the market.
                          Everything from flip opportunities, revenue properties
                          to new constructions.
                        </p>
                      </li>
                      <li>
                        <p>
                          <b>Traditional Home Buyers:</b> Let us connect you
                          with an agent in your area who will find you your
                          dream home. Our team of brokers will make the process
                          as seamless as possible, only send you properties
                          within your budget and negotiate the best price for
                          you.
                        </p>
                      </li>
                      <li>
                        <p>
                          <b>
                            Need assistance with a down payment or mortgage
                            approval?
                          </b>{' '}
                          We can help! Contact us today!
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='col-md-6'>
                  <div className='offers_boxs forms'>
                    <h4>Investors</h4>
                    <div className='contact-form contact-form-inputs-filled contact-form-button-block font-size-14'>
                      <form>
                        <div className='row'>
                          <div className='col-md-12'>
                            <label>Full Name</label>
                            <input
                              type='text'
                              className='form-control'
                              placeholder='Full Name'
                            />
                          </div>
                          <div className='col-md-6'>
                            <label>Phone Number</label>
                            <PhoneInput
                              country={'in'}
                              className='PhoneInput'
                              placeholder='Phone Number'
                              value={value}
                              onChange={setValue}
                            />
                          </div>
                          <div className='col-md-6'>
                            <label>Email</label>
                            <input
                              type='email'
                              className='form-control'
                              placeholder='Email'
                            />
                          </div>
                          <div className='col-md-12 button_box text-md-right'>
                            <input
                              type='submit'
                              className='bg-dark'
                              value='Submit'
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <section
          ref={aboutRef}
          id='aboutus'
          className='vc_row bg-contain ptb About-us'
        >
          <div className='container'>
            <div className='section-title'>
              <h1>About us</h1>
            </div>
            <div className='about_boxs'>
              <div className='row'>
                {/* Left Side: Image */}
                <div className='col-md-6'>
                  <div className='img_boxs'>
                    <img src={Icons.about} alt='About Us' />
                  </div>
                </div>

                {/* Right Side: Content */}
                <div className='col-md-6'>
                  <div className='offers_boxs contents'>
                    <h4>Who are we?</h4>
                    <p>
                      Backed by seasoned real estate investors and real estate
                      professionals alike, we offer a unique approach to selling
                      properties in Quebec.
                    </p>
                    <p>
                      Being tired of the traditional way real estate
                      transactions were being done, we sought out to do things
                      differently to save you thousands and get you top dollar.
                    </p>
                    <p className='getting-p'>
                      Our modern approach to getting you the highest cash offers
                      and being able to beat down broker fees, is a service
                      unlike any other.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <CustomSlider />
        {/* <PartnersSlider ref={partnerRef} handelContact={handelContact} /> */}
        <ReviewsSlider ref={reviewsRef} />
      </div>

      <Footer ref={contactRef} />
      <ToastContainer position='top-right' autoClose={3000} />
    </div>
  )
}
export default Home
